import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Wallet } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-[#F9F8F6]">
      {/* Left: sand texture */}
      <div className="hidden md:block relative sand-bg">
        <div className="absolute inset-0 bg-gradient-to-br from-[#8A5A44]/40 via-transparent to-[#2D2C2A]/40" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <div />
          <div />
        </div>
      </div>

      {/* Right: form */}
      <div className="flex items-center justify-center p-8 fade-in">
        <div className="w-full max-w-md">
          <div className="md:hidden mb-8" />

          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#5C5B57] mb-3">Hoş geldiniz</p>
          <h1 className="font-heading text-4xl sm:text-5xl text-[#2D2C2A] mb-8 leading-tight">
            Hesabınıza giriş yapın
          </h1>

          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="text-xs tracking-[0.15em] uppercase font-bold text-[#5C5B57] mb-2 block">E-posta</label>
              <input
                type="email"
                required
                autoComplete="off"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@sirket.com"
                data-testid="login-email"
                className="w-full bg-white border border-[#E6E4DD] rounded-xl px-4 py-3 text-[#2D2C2A] focus:ring-2 focus:ring-[#8A5A44]/20 focus:border-[#8A5A44] outline-none transition-all"
              />
            </div>
            <div>
              <label className="text-xs tracking-[0.15em] uppercase font-bold text-[#5C5B57] mb-2 block">Şifre</label>
              <input
                type="password"
                required
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="login-password"
                className="w-full bg-white border border-[#E6E4DD] rounded-xl px-4 py-3 text-[#2D2C2A] focus:ring-2 focus:ring-[#8A5A44]/20 focus:border-[#8A5A44] outline-none transition-all"
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-[#B24C4C] bg-[#B24C4C]/10 border border-[#B24C4C]/20 rounded-xl px-4 py-3">
                {error}
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full bg-[#8A5A44] text-white hover:bg-[#714835] rounded-xl px-6 py-3.5 font-medium transition-all disabled:opacity-60"
            >
              {loading ? "Giriş yapılıyor…" : "Giriş Yap"}
            </button>
            <p className="text-sm text-[#5C5B57] text-center">
              Hesabınız yok mu?{" "}
              <Link data-testid="link-register" to="/register" className="text-[#8A5A44] underline underline-offset-4 font-medium">
                Kayıt Ol
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
}
